module.exports = __webpack_public_path__ + "static/media/silvercar.001e0b47.png";